import React from 'react';
import { Send } from 'lucide-react';
import { psychologistInfo } from '../data/mock';

const FloatingTelegramButton = () => {
  return (
    <a
      href={psychologistInfo.social.telegram}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Написать в Telegram"
      className="animate-telegram-nudge fixed bottom-4 right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-sky-500 text-white shadow-xl transition-transform hover:scale-105 md:hidden"
    >
      <Send size={22} />
    </a>
  );
};

export default FloatingTelegramButton;
